
import React from "react";
import { GraduationCap } from 'lucide-react';
import { motion } from "framer-motion";

const educationData = [
    {
        icon: <GraduationCap />,
        degree: 'Master of Computer Applications',
        institution: 'LJ University',
        duration: 'Completed april 2026',
        details: 'Focusing on advanced software development principles and application design.'
    },
    {
        icon: <GraduationCap />,
        degree: 'Bachelor of Computer Applications',
        institution: 'KSV University, B.P College of Computer Studies',
        duration: 'Completed March 2024',
        details: 'Graduated with a CGPA of 7.3 (equivalent to 70.30%).'
    },
    {
        icon: <GraduationCap />,
        degree: 'Higher Secondary Certificate (HSC)',
        institution: 'DM Bard Higher Secondary School',
        duration: 'Completed May 2021',
        details: 'Completed with 54.94%.'
    },
    {
        icon: <GraduationCap />,
        degree: 'Secondary School Certificate (SSC)',
        institution: 'Alpha Vidhya Sankul - Talala(GIR)',
        duration: 'Completed March 2019',
        details: 'Completed with 69.33%.'
    },
];


const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: (i = 1) => ({
        opacity: 1,
        y: 0,
        transition: { delay: i * 0.2, duration: 0.7, ease: "easeOut" }
    })
};

const Education = ({ id }) => (
    <section id={id} className="py-20 px-4">
        <div className="container mx-auto">
                    <motion.h2
                        className="text-3xl md:text-4xl font-bold text-center mb-12 text-white"
                        initial="hidden"
                        animate="visible"
                        variants={fadeInUp}
                        custom={1}
                    >
                        Education
                        <div className="w-24 h-1 bg-cyan-400 mx-auto mt-2 rounded"></div>
                    </motion.h2>
            <div className="max-w-4xl mx-auto">
                <div className="relative border-l-2 border-cyan-500 pl-10">
                                {educationData.map((edu, idx) => (
                                    <motion.div
                                        key={idx}
                                        className="mb-12 relative"
                                        initial="hidden"
                                        whileInView="visible"
                                        viewport={{ once: true, amount: 0.5 }}
                                        variants={fadeInUp}
                                        custom={idx + 2}
                                        whileHover={{ scale: 1.03, rotate: 1 }}
                                    >
                                        <div className="absolute -left-[49px] top-1 text-cyan-400 bg-gray-900 p-2 rounded-full border-2 border-cyan-500">
                                            {edu.icon}
                                        </div>
                                        <div className="bg-gray-800 p-6 rounded-lg shadow-md">
                                            <motion.h3
                                                className="text-xl font-bold text-white"
                                                initial={{ color: "#fff" }}
                                                whileInView={{ color: ["#06b6d4", "#fff", "#06b6d4"] }}
                                                viewport={{ once: true, amount: 0.5 }}
                                                transition={{ duration: 2, repeat: Infinity, repeatType: "reverse" }}
                                            >
                                                {edu.degree}
                                            </motion.h3>
                                            <motion.p
                                                className="text-cyan-300 font-semibold my-1"
                                                initial="hidden"
                                                whileInView="visible"
                                                viewport={{ once: true, amount: 0.5 }}
                                                variants={fadeInUp}
                                                custom={idx + 3}
                                            >
                                                {edu.institution}
                                            </motion.p>
                                            <motion.p
                                                className="text-sm text-gray-400 mb-2"
                                                initial="hidden"
                                                whileInView="visible"
                                                viewport={{ once: true, amount: 0.5 }}
                                                variants={fadeInUp}
                                                custom={idx + 4}
                                            >
                                                {edu.duration}
                                            </motion.p>
                                            <motion.p
                                                className="text-gray-300"
                                                initial="hidden"
                                                whileInView="visible"
                                                viewport={{ once: true, amount: 0.5 }}
                                                variants={fadeInUp}
                                                custom={idx + 5}
                                            >
                                                {edu.details}
                                            </motion.p>
                                        </div>
                                    </motion.div>
                                ))}
                </div>
            </div>
        </div>
    </section>
);

export default Education;
